import { render, staticRenderFns } from "./NominaFiscal.vue?vue&type=template&id=2ca385b0&"
import script from "./NominaFiscal.vue?vue&type=script&lang=js&"
export * from "./NominaFiscal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports